import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { AssetType } from '@core/api/dashboard.enums';
import { CONFIG_TOKEN } from '@core/tokens';

import { AssetNamesResponse } from './assets.models';

@Injectable({ providedIn: 'root' })
export class AssetsService {
  readonly #ROOT_URL = inject(CONFIG_TOKEN).backendRootUrl;
  readonly #httpClient = inject(HttpClient);

  public getChargerNames$(siteId: string): Observable<AssetNamesResponse> {
    return this.#httpClient.get<AssetNamesResponse>(`${this.#ROOT_URL}/api/v1/assets/name`, {
      params: {
        siteId,
        assetType: AssetType.ChargingStation,
      },
    });
  }

  public getVehicleNames$(siteId: string): Observable<AssetNamesResponse> {
    return this.#httpClient.get<AssetNamesResponse>(`${this.#ROOT_URL}/api/v1/assets/name`, {
      params: {
        siteId,
        assetType: AssetType.ElectricVehicle,
      },
    });
  }
}
